import React from 'react';
import CTAButton from '../../components/CTAButton';
import './Solutions.css';

const Solutions = () => {
  return (
    <main>
      {/* Page Header Section */}
      <section className="page-header">
        <div className="page-header-bg">
          <div className="data-flow-bg"></div>
        </div>
        <div className="page-header-content">
          <h1 className="page-header-title">Intelligent Business Solutions</h1>
          <p className="page-header-subtitle">
            We architect and build end-to-end solutions that leverage AI and the Cloud to solve real-world challenges.
          </p>
        </div>
      </section>

      {/* AI & Automation Solutions Section */}
      <section className="ai-solutions-section">
        <div className="container">
          <h2 className="section-title">AI & Machine Learning Services</h2>
          <div className="solutions-grid">
            <div className="solution-card">
              <div className="solution-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M3 3v18h18"/>
                  <path d="M18.7 8l-5.1 5.2-2.8-2.7L7 14.3"/>
                </svg>
              </div>
              <h3>Predictive Analytics & Insights</h3>
              <p>
                We develop advanced AI/ML models that act as powerful predictors. Our systems analyze your data to forecast trends, identify opportunities, and provide the critical analytics you need to make smarter business decisions.
              </p>
            </div>
            
            <div className="solution-card">
              <div className="solution-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M12 2a3 3 0 0 0-3 3v7a3 3 0 0 0 6 0V5a3 3 0 0 0-3-3Z"/>
                  <path d="M19 10v2a7 7 0 0 1-14 0v-2"/>
                  <line x1="12" x2="12" y1="19" y2="22"/>
                  <line x1="8" x2="8" y1="22" y2="22"/>
                  <line x1="16" x2="16" y1="22" y2="22"/>
                </svg>
              </div>
              <h3>AI-Powered Assistants</h3>
              <p>
                We build intelligent assistants designed to automate tasks and enhance user engagement. From customer support chatbots to internal workflow automation tools, we create solutions that improve efficiency and responsiveness.
              </p>
            </div>
            
            <div className="solution-card">
              <div className="solution-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M12 2a3 3 0 0 0-3 3v7a3 3 0 0 0 6 0V5a3 3 0 0 0-3-3Z"/>
                  <path d="M19 10v2a7 7 0 0 1-14 0v-2"/>
                  <line x1="12" x2="12" y1="19" y2="22"/>
                  <line x1="8" x2="8" y1="22" y2="22"/>
                  <line x1="16" x2="16" y1="22" y2="22"/>
                </svg>
              </div>
              <h3>Business Process Automation</h3>
              <p>
                We transform your operations by implementing AI-driven automation. We analyze your workflows and build custom systems to handle repetitive tasks, streamline processes like KYC onboarding, and reduce manual error.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Scalable Cloud Infrastructure Section */}
      <section className="cloud-infrastructure-section">
        <div className="container">
          <h2 className="section-title">The Cloud Foundation for Modern AI</h2>
          <div className="cloud-content">
            <div className="cloud-text">
              <h3>Reliable, Scalable, and Secure</h3>
              <p>
                Powerful AI requires a robust and scalable infrastructure. Our expertise in DevOps and cloud-native architecture ensures your applications are built for high performance and reliability. We create secure, efficient systems that can grow with your business.
              </p>
            </div>
            <div className="cloud-logos">
              <div className="tech-logo">
                <div className="tech-icon">
                  <svg viewBox="0 0 24 24" fill="currentColor">
                    <path d="M6.76 4.84l-1.8-1.79-1.41 1.41 1.79 1.79 1.42-1.41zM4 10.5A1.5 1.5 0 0 1 5.5 9H6v2H5.5c-.83 0-1.5-.67-1.5-1.5zM4 5.5A1.5 1.5 0 0 1 5.5 4H6v2H5.5c-.83 0-1.5-.67-1.5-1.5zM7.5 4H8v2H7.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5zM7.5 8H8v2H7.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5zM7.5 12H8v2H7.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5zM10.5 4H11v2h-.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5zM10.5 8H11v2h-.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5zM10.5 12H11v2h-.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5zM13.5 4H14v2h-.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5zM13.5 8H14v2h-.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5zM13.5 12H14v2h-.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5zM16.5 4H17v2h-.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5zM16.5 8H17v2h-.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5zM16.5 12H17v2h-.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5z"/>
                  </svg>
                </div>
                <span className="tech-name">AWS</span>
              </div>
              <div className="tech-logo">
                <div className="tech-icon">
                  <svg viewBox="0 0 24 24" fill="currentColor">
                    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/>
                  </svg>
                </div>
                <span className="tech-name">Azure</span>
              </div>
              <div className="tech-logo">
                <div className="tech-icon">
                  <svg viewBox="0 0 24 24" fill="currentColor">
                    <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
                  </svg>
                </div>
                <span className="tech-name">Google Cloud</span>
              </div>
              <div className="tech-logo">
                <div className="tech-icon">
                  <svg viewBox="0 0 24 24" fill="currentColor">
                    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/>
                  </svg>
                </div>
                <span className="tech-name">Docker</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Custom Application Development Section */}
      <section className="app-development-section">
        <div className="container">
          <h2 className="section-title">Delivering Intelligence Through Intuitive Interfaces</h2>
          <div className="app-content">
            <div className="app-logos">
              <div className="tech-logo">
                <div className="tech-icon">
                  <svg viewBox="0 0 24 24" fill="currentColor">
                    <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
                  </svg>
                </div>
                <span className="tech-name">React</span>
              </div>
              <div className="tech-logo">
                <div className="tech-icon">
                  <svg viewBox="0 0 24 24" fill="currentColor">
                    <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
                  </svg>
                </div>
                <span className="tech-name">React Native</span>
              </div>
              <div className="tech-logo">
                <div className="tech-icon">
                  <svg viewBox="0 0 24 24" fill="currentColor">
                    <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
                  </svg>
                </div>
                <span className="tech-name">Node.js</span>
              </div>
              <div className="tech-logo">
                <div className="tech-icon">
                  <svg viewBox="0 0 24 24" fill="currentColor">
                    <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
                  </svg>
                </div>
                <span className="tech-name">Python</span>
              </div>
              <div className="tech-logo">
                <div className="tech-icon">
                  <svg viewBox="0 0 24 24" fill="currentColor">
                    <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
                  </svg>
                </div>
                <span className="tech-name">PostgreSQL</span>
              </div>
            </div>
            <div className="app-text">
              <h3>From Complex Code to User-Friendly Apps</h3>
              <p>
                An intelligent system is only as good as its interface. We specialize in building full-stack web and mobile applications that are fast, responsive, and intuitive. We ensure your users can seamlessly interact with the powerful AI and data processing happening behind the scenes.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Ready to Build CTA Section */}
      <section className="ready-to-build-section">
        <div className="container">
          <h2 className="cta-headline">Ready to transform your business with an intelligent solution?</h2>
          <p className="cta-subtext">
            Let's discuss your project. We provide cost-effective solutions for startups and enterprises alike.
          </p>
          <CTAButton variant="primary" size="large" href="/contact">Get a Free Consultation</CTAButton>
        </div>
      </section>
    </main>
  );
};

export default Solutions;
